<template>
    <section class="select-section">
        <el-dialog :visible.sync="dialogVisible" width="70%" center>
            <p slot="title">{{title}}</p>
            <div class="search-row">
                <el-input placeholder="请输入搜索内容" v-model="searchVal"
                 class="input-with-select" @keyup.enter='getData' size='small'>
                    <el-select style='width: 110px;' v-model="searchKey" slot="prepend" placeholder="请选择">
                        <el-option v-for='item in selectKey' :key='item.key'
                     :value="item.key" :label="item.name"></el-option>
                    </el-select>
                </el-input>
                <el-button type="primary" size='small'
                 @click='currentPage=1;getData()'>搜索</el-button>
            </div>
            <el-table :data="tableData" class="table_list" top='10vh' style="width: 100%" border max-height="500" @row-click='rowClickHandle'>
                <el-table-column label="选择" width="50px" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="choiceData" :label="scope.row">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="活动名称" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{scope.row.title || '-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="活动时间" min-width="10%">
                  <template slot-scope="scope">
                    <span>起：{{scope.row.startTime}}</span><br>
                    <span>止：{{scope.row.endTime}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="活动状态" min-width="10%">
                  <template slot-scope="scope">
                        <span>{{scope.row.startTime | stateFilter(scope.row.endTime)}}</span>
                  </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitHandle">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script scoped>
import selectReq from "@/api/selectSource";
export default {
  name: "selectLimitSale",
  data() {
    return {
        title: "",
        blank: "",
        choiceData: "",
        dialogVisible: false,
        selectKey: [
            {key: 'title',name: '活动名称'}
        ],
        searchKey: 'title',
        searchVal: "",
        pageSize: 20,
        currentPage: 1,
        totalCount: 0,
        tableData: [],
    };
  },
  mounted() {
  },
  methods: {
    open(title) {
      if(this.tableData.length==0){
        this.getData()
      }
      this.dialogVisible = true;
      this.title = title;
    },
    close() {
      this.dialogVisible = false;
    },
    submitHandle() {
        this.$emit('select-submit', this.choiceData)
        this.dialogVisible = false;
    },
    rowClickHandle(row) {
      this.choiceData = row;
    },
    getData() {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize
        // online: 1
      }
      params[this.searchKey] = this.searchVal
      selectReq.limitSale(params).then(res => {
        if (res.Success) {
          this.tableData = res.Data.dataList;
          this.totalCount = res.Data.totalCount;
        } else {
          this.$message.error(res.Msg);
        }
      }).catch(res => {
        this.$message.error('获取限时促销信息出错，请稍后再试！')
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    }
  },
    filters: {
        stateFilter(frist,second) {
            try{
                let now = new Date().getTime()
                let start = new Date(frist).getTime()
                let end = new Date(second).getTime()
                if(now < start){
                    return '未开始'
                }else if(now > start && now < end){
                    return '进行中'
                }else if(now > end){
                    return '已结束'
                }else{
                    return '未知'
                }
            }catch(e){
                console.log(e)
                return '未知'
            }
        }
    }
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
  .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap {
    margin-top: 10px;
  }
  .el-pagination {
    float: right;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  text-align: right;
  .input-with-select {
    width: 30%;
    min-width: 350px;
  }
  .search-select {
    width: 110px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/selectSource/selectLimitSale.vue